export default string =>
  string.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());



// WEBPACK FOOTER //
// ./src/utils/camelToDisplayText.js